import { motion } from 'framer-motion';
import React from 'react';

export const AnimatedBackground = () => {
  // Generate random stars with different sizes and positions
  const stars = React.useMemo(() => {
    return Array.from({ length: 100 }).map((_, i) => ({
      id: i,
      size: Math.random() * 3 + 1, // 1-4px
      x: Math.random() * 100, // 0-100%
      y: Math.random() * 100, // 0-100%
      duration: Math.random() * 3 + 2, // 2-5s
      delay: Math.random() * 2, // 0-2s
    }));
  }, []);

  return (
    <div className="fixed inset-0 -z-10 overflow-hidden bg-gradient-to-b from-[#0B0B3B] via-[#1A237E] to-[#311B92]">
      {/* Animated gradient overlay */}
      <motion.div
        className="absolute inset-0 opacity-30"
        animate={{
          background: [
            'radial-gradient(circle at 50% 50%, rgba(103, 58, 183, 0.3), transparent 80%)',
            'radial-gradient(circle at 50% 50%, rgba(103, 58, 183, 0.1), transparent 80%)',
            'radial-gradient(circle at 50% 50%, rgba(103, 58, 183, 0.3), transparent 80%)',
          ],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />

      {/* Stars */}
      {stars.map((star) => (
        <motion.div
          key={star.id}
          className="absolute rounded-full bg-white"
          style={{
            width: star.size,
            height: star.size,
            left: `${star.x}%`,
            top: `${star.y}%`,
          }}
          animate={{
            opacity: [0.2, 1, 0.2],
            scale: [1, 1.2, 1],
          }}
          transition={{
            duration: star.duration,
            repeat: Infinity,
            delay: star.delay,
            ease: "easeInOut"
          }}
        />
      ))}

      {/* Shooting stars */}
      <div className="absolute inset-0">
        {[...Array(3)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute h-px bg-gradient-to-r from-transparent via-white to-transparent"
            style={{
              width: '100px',
              transform: 'rotate(-45deg)',
            }}
            animate={{
              x: ['100%', '-100%'],
              y: ['0%', '100%'],
              opacity: [0, 1, 0],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              delay: i * 4,
              ease: "linear",
            }}
          />
        ))}
      </div>

      {/* Purple mist */}
      <motion.div
        className="absolute inset-0 bg-purple-900/20"
        animate={{
          opacity: [0.1, 0.2, 0.1],
        }}
        transition={{
          duration: 5,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
    </div>
  );
};